import {Card} from "../../../basic/card.tsx";
import {EmailCodeVerification} from "../../../shared/EmailCodeVerification.tsx";

/** Renders the shared verification panel inside the settings card layout. */
export function PendingEmailVerification(props: {
    newEmail?: string | null;
    expiresAt?: string | null;
    statusError: boolean;
    cancelling: boolean;
    confirming: boolean;
    resending: boolean;
    resendAvailableAt: number;
    onConfirm: (code: string) => void;
    onResend: () => void;
    onCancel: () => void;
}) {
    return (
        <Card className="p-6 shadow-sm border-border/50">
            <EmailCodeVerification keyPrefix="settings.emailChange" {...props} />
        </Card>
    );
}
